const accountDetails = {
  accountDetails: {
    managePreferences: 'Manage Preferences',
    email: 'Email',
    emailChangeText: 'You still need to confirm your email change!',
    confirmationText:
      'We’ve sent a confirmation email to %{email}. You must click the link that message before your email change will take effect.',
    resendConfirmationEmail: 'Resend confirmation email',
    cancelChange: 'Cancel this Change',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone Number',
    company: 'Company',
    saveDetails: 'Save Account Details',
    changeEmailRequest: 'Change Email',
    //TODO - new translations added
    apiKey: 'API Key',
    generate: 'Generate',
    apiKeySubtext: 'You may use this API token to securely integrate our API to your third party solutions',
    //TODO ends
    job_profile: {
      label: "Select job profile of the person in the company",
      tooltip_msg: "Select the primary job profile of the person. If the user has more than one primary role, select ‘Others’",
    }
  },
  resetPassword: {
    instructions:
      'Your password must be at least six characters, must contain at least one number or special character, and can’t be the same as your email address.',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password'
  }
};

export default accountDetails;
